import {Component, Inject, OnDestroy, OnInit, Optional, PLATFORM_ID, Renderer2} from '@angular/core';
import {AppService} from 'src/app/core/services/app.service';
import {SubSink} from 'subsink';
import {ActivatedRoute, Router} from '@angular/router';
import {Currency} from 'src/app/core/models/currency.model';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {ScriptService} from 'src/app/core/services/script.service';
import {Faq} from 'src/app/core/models/faq.model';
import {Observable} from 'rxjs';
import {Meta, Title} from '@angular/platform-browser';
import {DOCUMENT, isPlatformBrowser} from "@angular/common";
import {environment} from "../../../../../../environments/environment";

declare const TradingView: any;

@Component({
  selector: 'bit-main',
  templateUrl: './main.component.html',
  styleUrls: ['./main.component.scss']
})
export class MainComponent implements OnInit, OnDestroy {

  private sub = new SubSink();
  currency!: Currency;
  tradeType: 'Buy' | 'Sell' = 'Buy';
  tradeForm!: FormGroup;
  baseCurrencyFirst = true;
  faqList$!: Observable<Faq[]>;

  constructor(
    private route: ActivatedRoute,
    private formBuilder: FormBuilder,
    private scriptService: ScriptService,
    private appService: AppService,
    private title: Title,
    private meta: Meta,
    @Inject(PLATFORM_ID) private platformId: string,
    @Inject(DOCUMENT) private document: Document,
    private renderer: Renderer2,
    private router: Router,
    @Optional() @Inject('lang') private lang: string) {

  }

  changeTradeType(type: 'Buy' | 'Sell') {
    this.tradeType = type;
  }

  startTrading() {
    const amount = this.tradeForm.get('amount')?.value;
    if (isPlatformBrowser(this.platformId)) {
      if (amount) {
        window.location.href = `https://app.bit.ir/market/${this.currency.id}/IRR?amount=${amount}&type=${this.tradeType.toLowerCase()}`
      } else {
        window.location.href = `https://app.bit.ir/market/${this.currency.id}/IRR`;
      }
    }

  }

  ngOnInit(): void {
    this.tradeForm = this.formBuilder.group({
      amount: ['', Validators.required],
      price: ['', Validators.required]
    })
    this.sub.sink = this.tradeForm.get('amount')?.valueChanges.subscribe((val) => {
      const amount = parseFloat(val.toString().replace(/\,/g, ''));
      if (!isNaN(amount)) {
        const price = amount * (this.tradeType === 'Buy' ? this.currency.markets.irr.lastPrice.sell : this.currency.markets.irr.lastPrice.buy);
        if (this.tradeForm.get('price')?.value != price) {
          this.tradeForm.patchValue({
            price
          });
        }
      } else {
        this.tradeForm.patchValue({
          price: ''
        }, {emitEvent: false});
      }
    })
    this.sub.sink = this.tradeForm.get('price')?.valueChanges.subscribe((val) => {
      const price = parseFloat(val.toString().replace(/\,/g, ''));
      if (!isNaN(price)) {
        const amount = price / (this.tradeType === 'Buy' ? this.currency.markets.irr.lastPrice.sell : this.currency.markets.irr.lastPrice.buy);
        if (this.tradeForm.get('amount')?.value != amount) {
          this.tradeForm.patchValue({
            amount
          });
        }
      } else {
        this.tradeForm.patchValue({
          amount: ''
        }, {emitEvent: false});
      }
    })
    this.sub.sink = this.route.data.subscribe(data => {
      this.currency = data.currency;
      this.currency.markets.irr.lastPrice.buy = +this.currency.markets.irr.lastPrice.buy / 10;
      this.currency.markets.irr.lastPrice.sell = +this.currency.markets.irr.lastPrice.sell / 10;
      this.currency.markets.irr.avgPrice = +this.currency.markets.irr.avgPrice / 10;
      this.currency.markets.irr.maxPrice = +this.currency.markets.irr.maxPrice / 10;
      this.currency.markets.irr.volume24H = +this.currency.markets.irr.volume24H / 10;
      this.faqList$ = this.appService.getCurrencyFaqList(this.currency.id);
      if (this.currency.id === 'FEG') {
        this.title.setTitle($localize`خرید فگ | فروش فگ | قیمت فگ | bit.ir`);
        this.meta.updateTag({
          name: 'description',
          content: $localize`خرید فگ (FEG) به صورت لحظه ای به همراه نمودار تکنیکال در پلتفرم bit.ir`
        });
      } else if (this.currency.id === 'FLOKI') {
        this.title.setTitle($localize`خرید فلوکی | قیمت لحظه ای فلوکی | bit.ir`);
        this.meta.updateTag({
          name: 'description',
          content: $localize`مشاهده نمودار لحظه ای و خرید فلوکی اینو (Floki Inu) با نماد Floki در   bit.ir به صورت آنی و با کم ترین کارمزد`
        });
      } else {
        this.title.setTitle($localize`خرید فروش آنی خرید ${this.currency.name} | فروش ${this.currency.name} | قیمت لحظه ای ${this.currency.name}`);
      }
    })
    const script = this.scriptService.loadJsScript(this.renderer, 'https://s3.tradingview.com/tv.js');
    script.onload = () => {
      new TradingView.MediumWidget(
        {
          "symbols": [
            [
              this.currency.markets.usdt.tradingviewSymbol + '|12M'
            ]
          ],
          "chartOnly": false,
          "width": "100%",
          "height": "100%",
          "locale": "fa",
          "colorTheme": "dark",
          "gridLineColor": "rgba(240, 243, 250, 0)",
          "fontColor": "rgba(255, 255, 255, 1)",
          "isTransparent": true,
          "autosize": true,
          "showVolume": false,
          "scalePosition": "no",
          "scaleMode": "Normal",
          "fontFamily": "IRANSansMonospace, IRANSans, -apple-system BlinkMacSystemFont, SegoeUI, Trebuchet MS, Roboto, Ubuntu, sans-serif",
          "noTimeScale": false,
          "valuesTracking": "1",
          "chartType": "area",
          "lineColor": "#FFDA4C",
          "topColor": "rgba(255, 218, 76, 0.89)",
          "bottomColor": "rgba(255, 218, 76, 0)",
          "container_id": "tradingview_64813"
        }
      );
    }
    if (this.document) {
      const canonical = this.document.querySelector('link[rel="canonical"]');
      if (canonical) {
        if (isPlatformBrowser(this.platformId)) {
          this.renderer.setAttribute(canonical, 'href', window.location.href);
        } else {
          this.renderer.setAttribute(canonical, 'href', environment.domain + this.lang);
        }
      }
    }

  }

  ngOnDestroy(): void {
    this.sub.unsubscribe();
  }


}
